import { CMSResource } from "app/resources/cmsresource";
import { ClientFaqResource } from './ClientFaqResource';

export class ClientFaqListResource extends CMSResource {
    list: ClientFaqResource[];
}